/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const OrderIssueResolutionType = {
    FollowUp: 'FollowUp',
    DeleteOrder: 'DeleteOrder',
    RailcarFound: 'RailcarFound',
    ChangeOutboundTransport: 'ChangeOutboundTransport',
    ChangeInboundTransport: 'ChangeInboundTransport',
    ContainerFound: 'ContainerFound',
    UpdateCustomsStatus: 'UpdateCustomsStatus',
    UpdateOperator: 'UpdateOperator',
    UpdateConsignee: 'UpdateConsignee',
    UpdateForwarder: 'UpdateForwarder',
    UpdateShipper: 'UpdateShipper',
    ChangeToRestow: 'ChangeToRestow',
    ChangeToImport: 'ChangeToImport',
    UpdateCustomer: 'UpdateCustomer',
} as const;

export type OrderIssueResolutionType = typeof OrderIssueResolutionType[keyof typeof OrderIssueResolutionType];



